import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
interface IUrlsProcessingSummaryProps {
  failedFiles: string[];
  uploadedCount: number;
}

export const AttachmentFailedFilesSummary = observer((props: IUrlsProcessingSummaryProps): ReactElement => {
  const { t } = useTranslator();
  return (
    <div>
      {props.uploadedCount > 0 && <p>{t('upload_of_x_files_completed', { count: props.uploadedCount })}</p>}
      {t('failed_files')}
      <div>
        <ul>
          {props.failedFiles.map((u, i) => (
            <li key={i}>{u}</li>
          ))}
        </ul>
      </div>
    </div>
  );
});
